import React, { useEffect } from 'react';
import { Nav } from 'react-bootstrap';
import { Link, Outlet, useLocation } from 'react-router-dom';
import DocPageHeader from 'components/docs/DocPageHeader';
import useCustomer from 'hooks/useCustomer';
import { useLoading } from 'providers/LoadingProvider';
import { DATA_ACCESS_PATHS } from './paths';

const NAV_ITEMS = [
  { path: DATA_ACCESS_PATHS.apiTokens, label: 'API Tokens' },
  { path: DATA_ACCESS_PATHS.dataLake, label: 'Data Lake Access' },
  { path: DATA_ACCESS_PATHS.restApi, label: 'REST API' },
  { path: DATA_ACCESS_PATHS.mcpServer, label: 'MCP Server' },
] as const;

const DataAccessLayout: React.FC = () => {
  const { pathname } = useLocation();
  const { hideLoading } = useLoading();
  const customer = useCustomer();

  useEffect(() => {
    hideLoading();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    customer.fetchApiTokens();
  }, [customer.fetchApiTokens]);

  return (
    <div>
      <DocPageHeader
        title="Data Access"
        description="Connect to your carrier invoice data via the data lake, REST API, or MCP-compatible tools and automation."
      />

      <Nav className="mb-4 pb-1 gap-3 nav-underline flex-nowrap scrollbar overflow-auto">
        {NAV_ITEMS.map((item) => (
          <Nav.Item key={item.path}>
            <Nav.Link
              as={Link}
              to={item.path}
              className="text-nowrap"
              active={pathname === item.path}
            >
              {item.label}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>

      <Outlet context={customer} />
    </div>
  );
};

export default DataAccessLayout;
